import { UnaryExpression } from "./abstract.unary.expression";
import { FunctionExpression } from "./abstract.functionExpression";

export class ContainsFunction extends FunctionExpression 
{
    constructor(field: string | UnaryExpression, value: string) 
    {
        super("contains", field, [value]);
    }
}
